import React from 'react';
import { Grid } from '@mui/material';
import {
  Image as ImageIcon,
  CheckCircle,
  Warning,
  FilterList,
} from '@mui/icons-material';
import { Product, Brand } from '../../types';
import { StatsCard } from '../dashboard';

interface ProductsStatsCardsProps {
  products: Product[];
  brands: Brand[];
}

const ProductsStatsCards: React.FC<ProductsStatsCardsProps> = ({ products, brands }) => {
  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="Total Products"
          value={products.length}
          icon={<ImageIcon />}
          color="primary.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="Approved"
          value={products.filter(p => p.verification_status === 'APPROVED').length}
          icon={<CheckCircle />}
          color="success.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="Pending Review"
          value={products.filter(p => p.verification_status === 'PENDING_REVIEW').length}
          icon={<Warning />}
          color="warning.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatsCard
          title="Active Brands"
          value={brands.length}
          icon={<FilterList />}
          color="info.main"
        />
      </Grid>
    </Grid>
  );
};

export default ProductsStatsCards;